<template>
  <div
    class="bgy-pagination"
    :style="{opacity: (options && options.total > 0) ? 1 : 0}"
  >
    <el-pagination
      :layout="options.layout"
      :total="options.total"
      :current-page="pageOptions.currentPage"
      :page-size="pageOptions.pageSize"
      :page-sizes="options.pageSizes"
      :pager-count="options.pagerCount"
      :disabled="options.disabled"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'BgyPagination',
  props: {
    options: {
      type: Object,
      required: true
    },
    pageEvent: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      pageOptions: this.options
    };
  },
  methods: {
    // 处理改变当前页
    handleCurrentChange(currentPage) {
      this.pageOptions.currentPage = currentPage;
      this.pageEvent();
    },
    // 处理改变每页条数
    handleSizeChange(pageSize) {
      this.pageOptions.currentPage = 1;
      this.pageOptions.pageSize = pageSize;
      this.pageEvent();
    }
  }
};
</script>

<style lang="scss" scoped>
.bgy-pagination {
  padding-top: 20px;
  text-align: right;
  background-color: var(--bg-block);
}
</style>
